import { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";

import { RouteGuard } from "./RouteGuard";

const VALID_TEST_RESULTS = new Set(["succeeded", "failed"]);

interface SsoTestResultGuardProps {
  children: ReactNode;
}

/** Test-SSO popup landing — only reachable after a round-trip with a result param. */
export const SsoTestResultGuard = ({ children }: SsoTestResultGuardProps) => {
  const [searchParams] = useSearchParams();
  const testResult = searchParams.get("test_result");
  const allowed = testResult !== null && VALID_TEST_RESULTS.has(testResult);

  return <RouteGuard allowed={allowed}>{children}</RouteGuard>;
};
